import React from 'react';
import { t } from 'i18next';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { routes } from '../../../../utils/constants';
import { colors, zIndexes } from '../../../../theme/style-helpers';
import {
  WidgetContainer, WidgetHeader, WidgetTitle, WidgetTableContainer,
} from '../css';
import { apiGetQuotesAll } from '../../../../services/quotes';
import Table from '../../table';
import AppModal from '../../modal';
import Toolbar from '../Toolbar';
import Loader from '../../loader';
import ResultsFeedback from '../ResultsFeedback';
import DownloadModal from './DownloadModal';
import XIcon from '../../../../assets/icons/x_icon.svg';

const ModalBoxStyle = {
  overlay: {
    backgroundColor: colors.BLACK + colors.OPACITY_70_ALPHA_HEX_SUFFIX,
    zIndex: zIndexes.MODAL,
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    maxWidth: '90em',
    backgroundColor: colors.LIGHT_GREY,
    padding: '0px 0px 30px 0px',
    overflowY: 'auto',
    height: 'auto',
    maxHeight: '900px',
  },
};

const CloseContainer = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '15px',
};

const ModalBody = {
  padding: '0px 48px',
};

class QuotesWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stts: 'loading',
      data: [],
      modal: {
        isOpen: false,
        title: '',
        subtitle: '',
        actions: null,
        supportMsg: null,
      },
      isDownloadReportModalOpen: false,
    };
  }

  componentDidMount() {
    this.getQuotes();
  }

  getQuotes = async () => {
    const {
      itemsToShow, ordering, sorting, limitDate, accounts,
    } = this.props;

    const today = new Date();
    const pastMonth = new Date().setDate(today.getDate() - 30);
    const todayDt = format(today, 'MMMM d, yyyy').split('+')[0];
    const pastMonthDt = format(pastMonth, 'MMMM d, yyyy').split('+')[0];
    const pageSize = (itemsToShow) || 20;
    const orderBy = (ordering) || 'CreatedTime';
    const sortBy = (sorting) || 'desc';
    const limitedFrom = (limitDate) || pastMonthDt;
    const accountNumbers = (accounts) || [];

    const response = await apiGetQuotesAll(accountNumbers, null, null, null, limitedFrom, todayDt, pageSize, 1, orderBy, sortBy);

    if (response.status === 200) {
      if (response.data && response.data.total && response.data.total > 0) {
        const dataObj = response.data.quotesItems.map((item) => {
          if (!item.shipper.name) {
            item.shipper.name = ' ';
          }

          if (!item.consignee.name) {
            item.consignee.name = ' ';
          }

          return item;
        });

        this.setState({ data: dataObj, stts: 'loaded' });
      } else {
        this.setState({ stts: 'no-results' });
      }
    } else {
      this.setState({ stts: 'error' });
    }
  };

  closeModal = (callback) => {
    const { modal } = this.state;
    const updatedModal = { ...modal };
    updatedModal.isOpen = false;

    if (callback) {
      this.setState({ modal: updatedModal }, callback);
    }

    if (!callback) {
      this.setState({ modal: updatedModal });
    }
  };

  handleDownloadReportClick = () => {
    this.setState({ isDownloadReportModalOpen: true });
  };

  closeDownloadReportModal = () => {
    this.setState({ isDownloadReportModalOpen: false });
  };

  manageQuotes = () => {
    window.open(`${routes.manageQuotes}`);
  };

  createNewQuote = () => {
    window.open(`${routes.createQuote}`);
  };

  render() {
    const {
      stts, data, modal, isDownloadReportModalOpen,
    } = this.state;
    const {
      className, isAuthenticated, fields, resolution, scrollbarheight, paddingicons, iconsheight, accounts,
    } = this.props;
    const { requestQuoteLink, noResultsText, loadingText } = fields;

    const columns = [
      {
        id: 'Actions',
        header: t('Actions'),
        accessor: 'actions',
        type: 'actions',
        params: {
          options: [
            { id: 'PrintQuote' },
            { id: 'CreateShipmentFromQuote' },
            { id: 'CreateNewQuoteFromThisQuote' },
          ],
        },
      },
      {
        id: 'Reference',
        header: t('QuoteNumber'),
        accessor: 'quoteNumber',
        type: 'normal',
      },
      {
        id: 'Shipper',
        header: t('shipper'),
        accessor: 'shipper.name',
        type: 'name-and-location',
        params: { obj: 'shipper', width: 350 },
      },
      {
        id: 'Consignee',
        header: t('consignee'),
        accessor: 'consignee.name',
        type: 'name-and-location',
        params: { obj: 'consignee', width: 350 },
      },
      {
        id: 'Stts',
        header: t('Status'),
        accessor: 'status',
        type: 'normal',
      },
      {
        id: 'Created',
        header: t('Created'),
        accessor: 'createdDate',
        type: 'datetime',
      },
    ];

    const toolbarActions = [
      { label: t('DownloadReport'), action: this.handleDownloadReportClick, icon: 'DownloadIcon' },
      { label: t('ViewAllOrManage'), action: this.manageQuotes, icon: 'ViewIcon' },
      { label: t('RequestQuote'), action: this.createNewQuote, icon: 'CreateShipmentIcon' },
    ];

    return (
      <WidgetContainer className={className}>

        <Modal
          isOpen={isDownloadReportModalOpen}
          onRequestClose={this.closeDownloadReportModal}
          style={ModalBoxStyle}
          contentLabel="Download Report Modal"
        >
          <div style={CloseContainer}>
            <img src={XIcon} alt={t('Close')} onClick={this.closeDownloadReportModal} style={{ cursor: 'pointer' }} aria-hidden />
          </div>
          <div style={ModalBody}>
            <DownloadModal
              accountNumbers={accounts}
              closeModal={this.closeDownloadReportModal}
            />
          </div>
        </Modal>

        <AppModal
          isOpen={modal.isOpen}
          handleClose={this.closeModal}
          title={modal.title}
          subtitle={modal.subtitle}
          actions={modal.actions}
          support={modal.supportMsg}
          isAuthenticated={isAuthenticated}
        />

        <WidgetHeader>
          <WidgetTitle>{t('Quotes')}</WidgetTitle>
          <Toolbar options={toolbarActions} resolution={resolution} paddingicons={paddingicons} iconsheight={iconsheight} />
        </WidgetHeader>

        <WidgetTableContainer>

          {(stts === 'loading' || stts === 'updating')
            ? <Loader subtitle={loadingText.value} isLoading />
            : null}

          {(stts === 'loaded')
            ? (
              <Table
                datasource={data}
                columns={columns}
                viewAll={this.manageQuotes}
                resolution={resolution}
                scrollbarheight={scrollbarheight}
              />
            )
            : null}

          {(stts === 'no-results')
            ? (
              <ResultsFeedback
                icon="ShipmentTrackingIcon"
                message={noResultsText.value}
                ctaLabel={
                        (requestQuoteLink && requestQuoteLink.jss && requestQuoteLink.jss.value && requestQuoteLink.jss.value.text)
                        || t('CreateQuote')
                    }
                ctaAction={this.createNewQuote}
              />
            )
            : null}

        </WidgetTableContainer>

      </WidgetContainer>
    );
  }
}

QuotesWidget.propTypes = {
  className: PropTypes.string,
  itemsToShow: PropTypes.number,
  ordering: PropTypes.string,
  sorting: PropTypes.string,
  limitDate: PropTypes.instanceOf(Date),
  accounts: PropTypes.array,
  isAuthenticated: PropTypes.bool,
  fields: PropTypes.object,
  resolution: PropTypes.string,
  scrollbarheight: PropTypes.string,
  paddingicons: PropTypes.string,
  iconsheight: PropTypes.string,
};

export default QuotesWidget;
